import { createFileRoute } from "@tanstack/react-router";
import HorizonBlueInsurance, { config } from "@/pages/HorizonBlueInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/horizon-blue-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Horizon BCBS New Jersey TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Have Horizon Blue Cross Blue Shield of New Jersey? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your.",
        },
        {
          property: "og:title",
          content: "Horizon BCBS New Jersey TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Have Horizon Blue Cross Blue Shield of New Jersey? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/horizon-blue-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/horizon-blue-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HorizonBlueInsurance />;
}
